// Links
// Main nav items pointing to same page
$(once('se-ascroll', 'body')).on('click', '.ascroll', function (e) {
    e.preventDefault();
    let target = jQuery(this).attr('href');
    scrollToHash(target);
    history.pushState(null, null, target);
});

$(once('se-skip', 'body')).on('click', '.lnk-skip', function (e) {
    e.preventDefault();
    let target = jQuery(this).attr('href');
    scrollToHash(target);
});

$(once('se-totop', 'body')).on('click', '.totop', function (e) {
    e.preventDefault();
    let target = jQuery(this).attr('href');
    scrollToHash(target);
});

const scrollToHash = function (target) {
    let headerHeight;
    let targetElem = jQuery(target);

    if (jQuery('.main-head').css('position') === 'fixed') {
        headerHeight = jQuery('.main-head').outerHeight();
    } else {
        headerHeight = 0;
    }

    let scrollTo = (jQuery(targetElem).offset());

    if (scrollTo) {
        jQuery(document).trigger('scroll');
        let scrollTarget = (scrollTo.top - headerHeight);

        jQuery('html, body').animate({
            scrollTop: scrollTarget
        }, 500, null, function () {
            $(targetElem).attr('tabindex', '0');
            $(targetElem).trigger('focus');
        });
    }
}
